import React, { Component } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { Spin, message, Select,DatePicker } from "antd";
import Bridge from "./utils/Bridge";
import { ECAS_FORM_TYPES } from "./utils/consts";
import moment from 'moment';
import dayjs from 'dayjs';

const { Option } = Select

export default class AddPhysicalEcasForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      old_password: "",
      new_password: "",
      confirm_password: "",
      confirm_type: "password",
      new_type: "password",
      old_type: "password",
      loading: false,
      ecas_form_type:[],
      date:null,
      form_pdf:[],
      langauge_score:'',
      verbal_fluency_score:'',
      executive_score:'',
      memory_score:'',
      visuospatial_score:'',
    };
  }
  componentDidMount() {}
  save_form = () => {
    if (this.state.ecas_form_type.length==0) {
      message.warning("Please select form type.");
      return;
    } else if (!this.state.date) {
      message.warning("Please select date.");
      return;
    } else if (!this.state.form_pdf) {
      message.warning("Please select file");
      return;
    }
   
    if (Number(this.state.langauge_score)<0==true ||
      Number(this.state.langauge_score)>100==true
    ) {
      message.warning("Please enter correct value for language score");
      return;
    } 
    if (Number(this.state.verbal_fluency_score)<0==true ||
      Number(this.state.verbal_fluency_score)>100==true
    ) {
      message.warning("Please enter correct value for verbal fluency score");
      return;
    } 
    if (Number(this.state.executive_score)<0==true ||
      Number(this.state.executive_score)>100==true
    ) {
      message.warning("Please enter correct value for executive score");
      return;
    } 
    if (Number(this.state.memory_score)<0==true ||
      Number(this.state.memory_score)>100==true
    ) {
      message.warning("Please enter correct value for memory score");
      return;
    } 
    if (Number(this.state.visuospatial_score)<0==true ||
      Number(this.state.visuospatial_score)>100==true 
      
    ) {
      message.warning("Please enter correct value for visuospatial score");
      return;
    } 

   

    let formData=new FormData();
    formData.append('form_type', JSON.stringify(this.state.ecas_form_type))
    formData.append('date', this.state.date)
    if(this.state.form_pdf.length>0){
      for(let i=0; i<this.state.form_pdf.length; i++){
        formData.append('files[]', this.state.form_pdf[i])
      }
    }
   
    formData.append('langauge_score', this.state.langauge_score)
    formData.append('verbal_fluency_score', this.state.verbal_fluency_score)
    formData.append('executive_score', this.state.executive_score)
    formData.append('memory_score', this.state.memory_score)
    formData.append('visuospatial_score', this.state.visuospatial_score)
    formData.append('eals_id', localStorage.getItem("ap_eals_id"))
   
    this.setState({ loading: true });
    Bridge.personal_data_viewer.ecas_study.save_physical_ecas_form(formData)
      .then((response) => {
     
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState({
            loading: false,
          },()=>{
            window.location.reload();
          });
        } else {
          message.warning(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.error("Please try againdf!!");
        this.setState({ loading: false });
      });
  };
  onChangeDate = (date, dateString) => {
    this.setState({  date: dateString })
  };
  render() {
    return (
      <div>
        <Header />
        <div
          className="main-content demographics-wrapper physical_ecas_form"
          style={{ paddingTop: 40 }}
        >
          <div className="container" style={{ minHeight: 300 }}>
            <div className="row">
              <div className="col-lg-6">
                <a href="/my-personal-data-viewer" style={{width:95}} className="dashboard-back-arrow mt-0">
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Back
                </a>
                <Spin spinning={this.state.loading}>
                  <div className="change-password-form">
                    <h3 className="pb-0 mb-0">Upload ECAS Form</h3>
                    <hr />
                    <div className="form-group pt-4 mb-4">
                      <label className="input-heading mb-2">
                        Form Type <span className="text-danger">*</span> 
                      </label>
                      <Select
                        value={this.state.ecas_form_type}
                        style={{width:"100%",height:48}}
                        onChange={(e) =>
                          this.setState({ ecas_form_type: e })
                        }
                        mode="multiple"
                        allowClear
                      >
                        {ECAS_FORM_TYPES.map((item,index)=>{
                          return (
                            <Option value={item} key={index}>{item}</Option>
                          )
                        })}
                      </Select>
                    </div>
                    <div className="form-group mb-4">
                      <label className="input-heading mb-2">
                        Date <span className="text-danger">*</span> 
                      </label>
                      <DatePicker 
                        onChange={this.onChangeDate} 
                        format="MM/DD/YYYY"
                        style={{width:"100%"}}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label className="input-heading mb-2">
                        File <span className="text-danger">*</span> &nbsp;
                      </label>
                      <input
                        type={'file'}
                        onChange={(e) =>{
                          this.setState({ form_pdf: e.target.files })
                        }}
                        className="form-control"
                        style={{padding:"11px 22px"}}
                        multiple={true}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label className="input-heading mb-2">
                        Scores
                      </label>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Language Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.langauge_score}
                          onChange={(e) =>{
                            this.setState({ langauge_score: e.target.value })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                        Verbal Fluency Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.verbal_fluency_score}
                          onChange={(e) =>{
                            this.setState({ verbal_fluency_score: e.target.value })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                        Executive Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.executive_score}
                          onChange={(e) =>{
                            this.setState({ executive_score: e.target.value })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                        Memory Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.memory_score}
                          onChange={(e) =>{
                            this.setState({ memory_score: e.target.value })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                        Visuospatial Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.visuospatial_score}
                          onChange={(e) =>{
                            this.setState({ visuospatial_score: e.target.value })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                    </div>
                    <button
                      className="submit-button"
                      onClick={() => this.save_form()}
                    >
                      Submit{" "}
                      <box-icon
                        name="chevron-right"
                        color="#fff"
                        style={{ position: "relative", top: 1 }}
                      ></box-icon>
                    </button>
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
